module.exports = __webpack_public_path__ + "img/9.d0e8f006.jpg";